import { RefObject, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GrappleModule } from "../../interfaces/api/GrappleModule";
import { Rototilt } from "../../interfaces/api/Rototilt";
import { EpiId } from "../../shared/enums/LinkEpiId";
import { productHelper } from "../../shared/helpers/productHelper";
import { ListObject } from "../../shared/types/ListObject";
import {
  ProductItem,
  ProductItemWithTypeName,
} from "../../shared/types/ProductItem";
import { useEpiserverLink } from "../../store/hooks/useEpiServerLink";
import { useMarket } from "../../store/hooks/useMarket";
import ProductSeperator from "../Products/ProductSeperator";
import ListDesktop from "../shared/ListTable/ListDesktop";
import ListItem from "../shared/ListTable/ListItem";
import ListItemImage from "../shared/ListTable/ListItemImage";
import ListMobile from "../shared/ListTable/ListMobile";
import ListRow, { ListSelectMode } from "../shared/ListTable/ListRow";
import ListTable from "../shared/ListTable/ListTable";

interface ToolsProductItemsListProps {
  onChange(productItem: GrappleModule | ListObject | Rototilt): void;
  productItems: ProductItemWithTypeName[];
  refToolsProductItemsList: RefObject<HTMLDivElement>;
  selectedToolsProductItems: ProductItem[];
}
const ToolsProductItemsList = ({
  onChange,
  productItems,
  refToolsProductItemsList,
  selectedToolsProductItems,
}: ToolsProductItemsListProps) => {
  const market = useMarket();
  const { t } = useTranslation("tools");
  const episerverLinks = useEpiserverLink();

  const getEpiserverUrl =(epiId): string => {
    if (episerverLinks && epiId) {
      const url = `${process.env.REACT_APP_URLPATH}${episerverLinks[epiId]
      }`;
        return url;
    }
    return "";
  }

  const isSelected = (productItemId: number): boolean => {
    if (!selectedToolsProductItems || selectedToolsProductItems.length === 0) {
      return false;
    }

    const index = selectedToolsProductItems.findIndex(
      (selectedToolsProductItem) =>
        selectedToolsProductItem.id === productItemId
    );

    return index > -1 ? true : false;
  };

  return (
    <div ref={refToolsProductItemsList}>
      <ProductSeperator />
      <h3>{`${productItems.length} ${t("number of results")}`}</h3>
      <ListTable>
        {productItems.map(
          (productItemWithTypeName: ProductItemWithTypeName) => {
            const productData = productHelper.getProductData({
              market,
              product: productItemWithTypeName,
              t,
            });
            const nameColumnWidth = "180px";
            const columnWidth = "100px";
            const mobileTitleWidth = "230px";
            return (
              <ListRow
                key={productItemWithTypeName.id}
                identifier={productItemWithTypeName.id.toString()}
                isSelected={isSelected(productItemWithTypeName.id)}
                object={productItemWithTypeName}
                onChange={(object) => {
                  onChange(object);
                }}
                selectMode={ListSelectMode.Multi}
              >
                <>
                  <ListDesktop
                    readMeText={`${t("readmore")}`}
                    readMeUrl={getEpiserverUrl(productItemWithTypeName.epiId)}
                  >
                    <ListItemImage product={productData} />
                    <ListItem
                      label={productData.nameLabel}
                      maxWidth={nameColumnWidth}
                      minWidth={nameColumnWidth}
                      truncate
                      value={productData.name}
                    />
                    {productData.properties.map((property, index) => {
                      return (
                        <ListItem
                          key={`property-${index}`}
                          label={property.label}
                          maxWidth={columnWidth}
                          minWidth={columnWidth}
                          value={property.text}
                        />
                      );
                    })}
                  </ListDesktop>
                  <ListMobile
                    content={productHelper.getHtmlContent(productData)}
                    imageLink={productItemWithTypeName.imageLink}
                    isSelected={isSelected(productItemWithTypeName.id)}
                    object={productItemWithTypeName}
                    onChange={(object) => {
                      onChange(object);
                    }}
                    preContent={`${t("tools")}`}
                    readMeText={`${t("readmore")}`}
                    readMeUrl={getEpiserverUrl(productItemWithTypeName.epiId)}
                    selectMode={ListSelectMode.Multi}
                    title={productItemWithTypeName.name}
                    titleMaxWidth={mobileTitleWidth}
                    titleTruncate
                  />
                </>
              </ListRow>
            );
          }
        )}
      </ListTable>
    </div>
  );
};

export default ToolsProductItemsList;
